import React, { useEffect } from 'react';
import { LayoutWithStepper } from 'layouts';
import { connect } from 'react-redux';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { stepAction, agreementAction } from 'shared/store/actions';
import selectors from 'shared/store/selectors';
import { PageContentWrapper } from 'components';
import {
  // CLIENT_CLASSIFICATION,
  PATH,
} from 'shared/constant';

import CheckIcon from 'assets/icons/big-check.svg';

const QualifiedConfirmation = ({
  intl: { formatMessage },
  onGetStepsProgress,
  formSignature, clientClassification, onGetAgreementStatus,
  history, isAgreementReadyForQualified,
  // isFirstAgreementCompleted,
}) => {
  useEffect(() => {
    onGetAgreementStatus();
    onGetStepsProgress();
  }, [onGetStepsProgress, onGetAgreementStatus]);

  useEffect(() => {
    // console.log('formSignature :: ', formSignature && isAgreementReadyForQualified)
    /** @todo add this condition: '&& clientClassification === CLIENT_CLASSIFICATION.QUALIFIED' on Dec 31 2023 to support for now the retail client  */
    if (formSignature && isAgreementReadyForQualified) {
      history.push(PATH.AGREEMENT);
    }
  }, [formSignature, clientClassification, history, isAgreementReadyForQualified]);

  const { location } = history;
  const isFirstVisit = !!(location.state && location.state.isFirstVisit);
  return (
    <PageContentWrapper isWithPadding isWithHeader>
      <section className="page-container page-container--whiteBg">
        <section className="page-container__content">
          <h1 className="isPrimary">{formatMessage({ id: isFirstVisit && !isAgreementReadyForQualified ? 'confirmation.thankyou' : 'navbar.qualifiedConfirmation' })}</h1>
          <article className="page-container__content__blueBg">
            <img src={CheckIcon} alt="Thank you!" />
            {isFirstVisit && !isAgreementReadyForQualified ? <FormattedHTMLMessage id="confirmation.qualified.1st" /> : <FormattedHTMLMessage id="confirmation.qualified.2ndVisit" />}
          </article>
        </section>
      </section>
    </PageContentWrapper>
  );
};

const mapStateToProps = state => ({
  fullName: selectors.getFullName(state),
  formSignature: selectors.getAofKycProfileSignature(state),
  clientClassification: selectors.getClientClassification(state),
  typeOfInvestment: selectors.getTypeOfInvestment(state),
  isAgreementReadyForQualified: selectors.getIsAgreementReadyStatus(state),
  isFirstAgreementCompleted: selectors.isFirstAgreementCompleted(state),
});

const mapDispatchToProps = dispatch => ({
  onGetStepsProgress: () => dispatch(stepAction.getProgress()),
  onGetAgreementStatus: () => dispatch(agreementAction.getQualifiedAgreementStatus()),
});


export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithStepper(injectIntl(QualifiedConfirmation)));
